export const triggerDownload = (url: string, filename?: string | null): void => {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.rel = 'noopener noreferrer'
  anchor.download = filename ?? ''
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}
